<template>
  <div class="main-logo" :class="{'dev': !isProd()}" @click="goToHome">
    <img class="img-logo">
    <img class="beta-logo" src="images/beta.png" v-if="showBeta">
  </div>
</template>
<script>
import { spinnakerApi } from '../js/SpinnakerApi.js'

export default {
  props: ['showBeta'],
  methods: {
    isProd () {
      return spinnakerApi.isProd()
    },
    goToHome () {
      this.$store.commit('navigation/goToHome')
    }
  }
}
</script>
